import { render, staticRenderFns } from "./CategoryAuthorCard.vue?vue&type=template&id=024abfba"
import script from "./CategoryAuthorCard.vue?vue&type=script&lang=js"
export * from "./CategoryAuthorCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryAuthorCard.vue?vue&type=style&index=0&id=024abfba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports